import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'

import { SPACING as constants } from '../../constants'

export const menuStyles = css`
  min-width: 80px;
  height: 100%;
  position: relative;

  display: grid;
  place-items: center;

  color: #333333;
  font-family: 'Gotham';
  font-size: 14px;
  text-align: center;

  user-select: none;
  cursor: pointer;
`

export const menuActiveStyles = css`
  color: #ad2624;
  font-family: 'Gotham-Medium';

  &::after {
    content: '';
    width: 100%;
    height: 3px;
    display: block;

    background-color: currentColor;

    position: absolute;
    bottom: 0;
  }
`

export default {
  Bar: styled.div`
    height: 50px;
    padding: 0 ${constants.GAP};
    margin-bottom: 10px;

    display: flex;
    align-items: center;

    background-color: #fff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.08);

    > :not(:last-child) {
      margin-right: ${constants.GAP};
    }
  `,
  Menu: styled.div`
    ${menuStyles}

    ${/** @param {{ active?: boolean }} props */
  props => props.active && menuActiveStyles}
  `,
  MenuLink: styled(NavLink)`
    ${menuStyles}

    &.active {
      ${menuActiveStyles}
    }
  `,
}



// WEBPACK FOOTER //
// ./src/lib/components/Tab.jsx